import { useTranslation as useI18nextTranslation } from 'react-i18next';
import type { Namespace } from '../i18n';

/**
 * Custom hook that wraps react-i18next's useTranslation with our type definitions
 * Provides type-safe translation functions for all namespaces
 */
export const useTranslation = (namespace?: Namespace) => {
  const { t, i18n, ready } = useI18nextTranslation(namespace);
  
  return {
    t,
    i18n,
    ready,
    // Helper functions for common operations
    changeLanguage: (lng: string) => i18n.changeLanguage(lng),
    currentLanguage: i18n.language,
    isLanguageSupported: (lng: string) => {
      const supportedLngs = i18n.options.supportedLngs;
      return Array.isArray(supportedLngs) ? supportedLngs.includes(lng) : false;
    },
  };
};

/**
 * Hook specifically for common translations (buttons, navigation, etc.)
 */
export const useCommonTranslation = () => useTranslation('common');

/**
 * Hook specifically for page translations
 */
export const usePageTranslation = () => useTranslation('pages');

/**
 * Hook specifically for component translations
 */
export const useComponentTranslation = () => useTranslation('components');

/**
 * Hook specifically for error translations
 */
export const useErrorTranslation = () => useTranslation('errors');

/**
 * Hook specifically for modal translations
 */
export const useModalTranslation = () => useTranslation('modals');